import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex footer-menu justify-content-between sm:justify-content-start" }
const _hoisted_2 = {
  key: 0,
  class: "sm:mr-s6 xl:mr-s8"
}
const _hoisted_3 = { class: "caption uppercase" }
const _hoisted_4 = { class: "pt-s4 xl:pt-s3" }
const _hoisted_5 = ["href"]

import Menu from 'primevue/menu';
import { useI18n } from 'vue-i18n';
import {
  EXTERNAL_LINKS,
  PRIVACY_POLICY,
  SOCIAL_LINKS,
  TERMS_OF_SERVICE
} from '@/constants/EXTERNAL_LINKS';


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterMenu',
  setup(__props) {

const { t } = useI18n();

const items = [
  {
    label: t('about'),
    visible: true,
    items: [
      {
        label: t('about') + ' Blueshift',
        url: EXTERNAL_LINKS.BLUESHIFT_ABOUT,
        visible: true,
      },
      {
        label: t('whitepaper'),
        url: EXTERNAL_LINKS.WHITEPAPER,
        visible: true,
      },
      {
        label: t('userAgreement.termsOfService'),
        url: TERMS_OF_SERVICE,
        visible: true,
      },
      {
        label: t('userAgreement.privacyPolicy'),
        url: PRIVACY_POLICY,
        visible: true,
      },
      {
        label: t('careers'),
        url: EXTERNAL_LINKS.CAREERS,
        visible: false,
      },
    ],
  },
  {
    label: t('community'),
    visible: true,
    items: [
      {
        label: 'Telegram (' + t('offGroup') + ')',
        visible: true,
        url: EXTERNAL_LINKS.TELEGRAM_OFF_GROUP,
      },
      {
        label: 'Telegram (' + t('chat') + ')',
        visible: true,
        url: EXTERNAL_LINKS.TELEGRAM_CHAT,
      },
      {
        label: 'Twitter',
        visible: true,
        url: SOCIAL_LINKS.TWITTER,
      },
      {
        label: 'Gitbook',
        visible: false,
        url: EXTERNAL_LINKS.GITBOOK,
      },
    ],
  },
  {
    label: t('support'),
    visible: true,
    items: [
      {
        label: t('FAQ'),
        visible: false,
        url: EXTERNAL_LINKS.BLUESHIFT_ABOUT,
      },
      {
        label: 'E-mail',
        url: SOCIAL_LINKS.MAIL,
      },
    ],
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (item.visible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(item.label), 1),
              _createVNode(_unref(Menu), {
                model: item.items
              }, {
                item: _withCtx(({ item }) => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("a", {
                      class: "menuitem-link",
                      role: "button",
                      href: item.url,
                      target: "_blank"
                    }, _toDisplayString(item.label), 9, _hoisted_5)
                  ])
                ]),
                _: 2
              }, 1032, ["model"])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 64))
  ]))
}
}

})